import { getSettingSelfServeRetailerTaxonomy } from "@faire/help-center-utils/settings/getSettingSelfServeRetailerTaxonomy";
import { useRetailerNodesV1 } from "./useRetailerNodesV1";
import { useRetailerNodesV2 } from "./useRetailerNodesV2";
export var useRetailerNodes = function useRetailerNodes() {
  var retailerNodesV1 = useRetailerNodesV1();
  var retailerNodesV2 = useRetailerNodesV2();
  if (getSettingSelfServeRetailerTaxonomy()) {
    return retailerNodesV2;
  }
  return retailerNodesV1;
};